import {createSlice} from "@reduxjs/toolkit";

const initialDownloadReport = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  reportList:[],
  userList:[],
  reportDropdownList: [],
 
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const DownloadReportSlice = createSlice({
  
  name: "DownloadReportSlice",
  initialState: initialDownloadReport,
  
    reducers: {
      catchError: (state, action) => {
        state.error = `${action.type}: ${action.payload.error}`;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = false;
        } else {
          state.actionsLoading = false;
        }
      },
      startCall: (state, action) => {
        state.error = null;
        if (action.payload.callType === callTypes.list) {
          state.listLoading = true;
        } else {
          state.actionsLoading = true;
        }
      },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    reportList: (state, action) => {
      const { totalCount,entities, } = action.payload;
      // console.log("entities slice",entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      // state.reportList = reportList;
      // console.log("Report List:", reportList); // Add this console log statement
    },
    UserList: (state, action) => {
      const { userList } = action.payload;
      console.log("entities slice",userList)
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.userList = userList;
    },
    ReportDropdownList: (state, action) => {
      const { reportDropdownList } = action.payload;
      console.log("entities slice",reportDropdownList)
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.reportDropdownList = reportDropdownList;
    },
    
  }
});
